/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_B21Inputs */

const en_job_form_enum_b21 = /** @type {(inputs: Job_Form_Enum_B21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B2 - Upper Intermediate`)
};

const de_job_form_enum_b21 = /** @type {(inputs: Job_Form_Enum_B21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B2 - Selbständige Sprachverwendung`)
};

/**
* | output |
* | --- |
* | "B2 - Upper Intermediate" |
*
* @param {Job_Form_Enum_B21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_b21 = /** @type {((inputs?: Job_Form_Enum_B21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_B21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_b21(inputs)
	return en_job_form_enum_b21(inputs)
});
export { job_form_enum_b21 as "job_form_enum_B2" }